import useErrorMessageHandler from '@/@core/helpers/errorMessageHandler';
import { toFormData } from '@/@core/helpers/formData';
import { useCallApi } from '@/@core/services/axiosCall';
import {
  reactive,
  Ref,
  ref,
  toRefs,
  unref
} from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useInfographicStore = defineStore('infographic', () => {
  const state = reactive({
    total: 0,
    infographics: []
  });

  async function getManyInfographic() {
    const { errorMessage, result, error } = await useCallApi({
      method: 'get',
      url: '/infographics'
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    state.infographics = result.infographics;
    state.total = result.count;

    return result;
  }

  async function postInfographic(data: any) {
    const formData = toFormData(data);
    if (data?.files?.length) {
      data.files.map((p: any) => formData.append('files', p));
    }

    const { errorMessage, result, error } = await useCallApi({
      method: 'post',
      url: '/infographics',
      data: formData
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function putInfographic(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'put',
      url: '/infographics/' + data.id,
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function deleteInfographic(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'delete',
      url: '/infographics/' + data.id
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }
  return {
    ...toRefs(state),
    getManyInfographic,
    postInfographic,
    deleteInfographic,
    putInfographic
  };
});
